import React, { Component } from 'react'
import { connect } from 'react-redux'

import {
  THEME_ELEVATION,
  THEME_ROUNDNESS,
  THEME_SPACING
} from 'shared/enums/index'

import {
  setThemeFont,
  setThemeColor,
  setThemeElevation,
  setThemeRoundness,
  setThemeSpacing
} from 'actions/theme'

import FormGroup from 'editor/FormGroup'
import Label from 'editor/Label'

import Sidebar from 'components/Sidebar'
import SidebarContent from 'components/SidebarContent'
import SidebarHeadline from 'components/SidebarHeadline'
import ThemeOptions from 'components/ThemeOptions'
import ThemeOption from 'components/ThemeOption'
import ThemeIconElevation from 'components/ThemeIconElevation'
import ThemeIconRoundness from 'components/ThemeIconRoundness'
import ThemeIconSpacing from 'components/ThemeIconSpacing'
import ThemeColors from 'components/ThemeColors'
import ThemeColor from 'components/ThemeColor'
import ThemeFont from 'components/ThemeFont'

class ThemeEditor extends Component {
  render() {
    return (
      <Sidebar anchor="right" isOpen>
        <React.Fragment>
          <SidebarContent>
            <SidebarHeadline>Theme</SidebarHeadline>

            <FormGroup>
              <Label>Colors</Label>

              <ThemeColors amount={3}>
                <ThemeColor
                  align="left"
                  label="Primary"
                  value={this.props.colors.primary}
                  onChange={value => this.props.setThemeColor('primary', value)}
                />

                <ThemeColor
                  align="center"
                  label="White"
                  value={this.props.colors.white}
                  onChange={value => this.props.setThemeColor('white', value)}
                />

                <ThemeColor
                  align="right"
                  label="Black"
                  value={this.props.colors.black}
                  onChange={value => this.props.setThemeColor('black', value)}
                />
              </ThemeColors>
            </FormGroup>

            <FormGroup>
              <Label>Font Family</Label>

              <ThemeFont
                value={this.props.fonts.primary}
                onChange={value => this.props.setThemeFont('primary', value)}
              />
            </FormGroup>

            <FormGroup>
              <Label>Shadows</Label>

              <ThemeOptions amount={Object.entries(THEME_ELEVATION).length}>
                {Object.entries(THEME_ELEVATION).map(([value, option]) => (
                  <ThemeOption
                    key={`elevation-${value}`}
                    label={option.label}
                    isActive={this.props.elevation === parseInt(value, 10)}
                    onClick={() => this.props.setThemeElevation(parseInt(value, 10))}
                  >
                    <ThemeIconElevation
                      value={parseInt(value, 10)}
                      isActive={this.props.elevation === parseInt(value, 10)}
                    />
                  </ThemeOption>
                ))}
              </ThemeOptions>
            </FormGroup>

            <FormGroup>
              <Label>Roundness</Label>

              <ThemeOptions amount={Object.entries(THEME_ROUNDNESS).length}>
                {Object.entries(THEME_ROUNDNESS).map(([value, option]) => (
                  <ThemeOption
                    key={`roundness-${value}`}
                    label={option.label}
                    isActive={this.props.roundness === parseInt(value, 10)}
                    onClick={() => this.props.setThemeRoundness(parseInt(value, 10))}
                  >
                    <ThemeIconRoundness
                      value={parseInt(value, 10)}
                      isActive={this.props.roundness === parseInt(value, 10)}
                    />
                  </ThemeOption>
                ))}
              </ThemeOptions>
            </FormGroup>

            <FormGroup>
              <Label>Spacing</Label>

              <ThemeOptions amount={Object.entries(THEME_SPACING).length}>
                {Object.entries(THEME_SPACING).map(([value, option]) => (
                  <ThemeOption
                    key={`spacing-${value}`}
                    label={option.label}
                    isActive={this.props.spacing === parseInt(value, 10)}
                    onClick={() => this.props.setThemeSpacing(parseInt(value, 10))}
                  >
                    <ThemeIconSpacing
                      value={parseInt(value, 10)}
                      isActive={this.props.spacing === parseInt(value, 10)}
                    />
                  </ThemeOption>
                ))}
              </ThemeOptions>
            </FormGroup>
          </SidebarContent>
        </React.Fragment>
      </Sidebar>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setThemeFont: (key, value) => dispatch(setThemeFont(key, value)),
    setThemeColor: (key, value) => dispatch(setThemeColor(key, value)),
    setThemeElevation: value => dispatch(setThemeElevation(value)),
    setThemeRoundness: value => dispatch(setThemeRoundness(value)),
    setThemeSpacing: value => dispatch(setThemeSpacing(value))
  }
}

const mapStateToProps = (state) => {
  return {
    fonts: {
      primary: state.project.theme.fonts.primary
    },
    colors: {
      primary: state.project.theme.colors.primary,
      black: state.project.theme.colors.black,
      white: state.project.theme.colors.white
    },
    elevation: state.project.theme.elevation,
    roundness: state.project.theme.roundness,
    spacing: state.project.theme.spacing
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeEditor)



// WEBPACK FOOTER //
// ./src/components/ThemeEditor/index.js